import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {CarsModel} from '../model/car.model';
import {HttpClient} from '@angular/common/http';
import {FilterModel} from '../model/FilterModel';

@Injectable({
  providedIn: 'root'
})
export class CarService {
  public sortingVal = 'sortBy';
  private carApi = 'https://vmgplay.co.za/api/v3/view_stock_complete_with_data?company_id=eq.2997';
  private carApiHome = 'https://vmgplay.co.za/api/v3/view_stock_complete_with_data?company_id=eq.2997&limit=5&order=date_created.desc';
  filterList: FilterModel[] = [];

  constructor(
    private http: HttpClient
  ) { }

  getListData(query: string): Observable<FilterModel[]> {
    return this.http.get<FilterModel[]>(this.carApi + query);
  }
  getAllCars(filterValues: string = ''): Observable<CarsModel[]> {
    return this.http.get<CarsModel[]>(this.carApi + filterValues);
  }
  getCarsHomePage(filterValues: string = ''): Observable<CarsModel[]> {
    return this.http.get<CarsModel[]>(this.carApiHome + filterValues);
  }
  getAllCarsFilter(car: CarsModel = {}): Observable<any> {
    let filterString = '';
    if (car.make !== null && car.make !== '') {
      filterString += `&make=eq.${car.make}`;
    }
    if (car.series !== undefined && car.series !== '' && car.series !== null) {
      filterString += `&series=eq.${car.series}`;
    }
    if (car.year !== null && car.year !== undefined && car.year !== '') {
      filterString += `&year=eq.${car.year}`;
    }
    if (car.lowValue !== undefined) {
      filterString += `&selling_price=gt.${car.lowValue}`;
    }
    if (car.highValue !== undefined) {
      filterString += `&selling_price=lt.${car.highValue}`;
    }
    if (car.mileageLow !== undefined) {
      filterString += `&mileage=gt.${car.mileageLow}`;
    }
    if (car.mileageHigh !== undefined) {
      filterString += `&mileage=lt.${car.mileageHigh}`;
    }

    return this.http.get<CarsModel[]>(this.carApi + filterString);
  }

  getCar(car: CarsModel): Observable<CarsModel[]> {
    let filterString = '';

    if (car.stock_id !== null && car.stock_id !== '') {
      filterString += `&stock_id=eq.${car.stock_id}`;
    }
    if (car.make !== null && car.make !== '') {
      filterString += `&make=eq.${car.make}`;
    }
    if (car.series !== null && car.series !== '' && car.series !== undefined) {
      filterString += `&series=eq.${car.series}`;
    }
    return this.http.get<CarsModel[]>(this.carApi + filterString);
  }

  filterCars(car: CarsModel): Observable<any> {
    return this.http.get<CarsModel[]>(this.carApi);
  }
}
